import React from 'react';
import './App.scss';
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import { APP, LOGIN } from './Constants/Routes'
import Login from './Pages/Login'
import AppInside from './Components/AppInside'
import ReactNotification from 'react-notifications-component'
import ConfirmDialog from 'Components/AppDialog/ConfirmDialog'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import uiStore from 'stores/uiStore'
import i18n from 'i18n'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
})

const getUserConfirmation = (message, callback) => {
  uiStore.confirm({
    message,
    title: i18n.t('attention'),
    confirmLabel: i18n.t('continue'),
    cancelLabel: i18n.t('cancel'),
    variant: 'warning',
  }).then(callback)
}

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <Router getUserConfirmation={getUserConfirmation}>
        <div>
          <ReactNotification />
          <ConfirmDialog />
          <Switch>
            <Route exact path={LOGIN} component={Login} />
            <AppInside path={APP} />
            <Redirect to={LOGIN} />
          </Switch>
        </div>
      </Router >
    </QueryClientProvider>)
}


export default App;
